module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10027.b428579c.jpg";